/** Invalidates saved Fitness reads without importing a client or applying receipt history. */
export const FITNESS_CHANGED = 'vyv:fitness-changed';
export const notifyFitnessChanged = () => window.dispatchEvent(new Event(FITNESS_CHANGED));
